import noop from './noop';

type ConsoleMock = {
	error: () => void;
	log: () => void;
	info: () => void;
	warn: () => void;
	debug: () => void;
};

let logger: Console | ConsoleMock;

if (['development', 'test'].includes(process.env.NODE_ENV ?? '')) {
	logger = window.console;
} else {
	logger = {
		error: noop,
		log: noop,
		info: noop,
		warn: noop,
		debug: noop,
	};
}

export default logger;
